import { DEFAULT } from '@/constant';
import { Merchant } from './interface';
import { PostMessage } from './types';

import { createI18n } from 'vue-i18n';
import merge from 'lodash.merge';
import store from '@/store';

// Convert from UTC
export const convertDate = (date: string): string => 
  date ? new Date(date).toString() : new Date().toString();

export const setLang = (locale: string = 'ru', merchant: string = DEFAULT) => {
  locale = (locale === 'en') ? 'ru' : locale;

  const defaultMessages= require(`@/lang/${locale}/default.json`); 
  const merchantMessages = merchant !== DEFAULT  ? require(`@/lang/${locale}/${merchant}.json`) : [];
  
  const messages = {
    [locale]: merge(defaultMessages, merchantMessages)
  };

  return createI18n({
    legacy: false,
    locale,
    messages
  });
};

export const getMerchant = (tk?: string) => {
  
  const body: HTMLBodyElement = document.getElementsByTagName('body')[0];

  // const authenticationError = 'authentication-error';
  let merchant: Merchant = {
    merchant_name: 'default',
    expired_at: '',
    language: '',
    test_mode: 0,
    validation_key: '',
    gtm_own: '',
    gtm_outside: ''
  };

  const url = new URL(window.location.href);
  const token = tk || url.searchParams.get('token');

  if (!token) {
    // router.push({
    //   name: authenticationError,
    // });
    return;
  }
  try {
    const decodeToken = decodeURIComponent(token).split('@');

    const decodeBase64 = window.atob(decodeToken[0]);
    merchant = {...JSON.parse(decodeBase64) };
    
    store.commit('setToken', token);
    store.commit('setLanguage', merchant.language);
    store.commit('setMerchant', merchant.merchant_name);
  
  } catch (error) {
    // router.push({
    //   name: authenticationError,
    // });
    return;
  }
  
  body.setAttribute('class', merchant.merchant_name); 

  return merchant;
};
export const sendPostMessage = (action: string, status: string, data: string) => {
  const message: PostMessage = {
    action,
    status,
    data,
  };

  if (data) {
    message.data = data;
  }

  window.parent.postMessage(message, '*');
};

export const setTheme = (payload: string = 'default'): void => {
  const body: HTMLBodyElement = document.getElementsByTagName('body')[0];
  body.setAttribute('class', payload);
};

export const decodeBase64 = (payload: string): string  => window.atob(payload);

export const t = (key: string): string => {
  const lang = window.parent.localStorage.getItem('lang') || 'ru';
  return key.replace(/\s/g, '').split('.').reduce((a, b) => a[b],
    require('../lang/' + lang).data) ?? 'Перевод отсутствует';
};

export const formatNumber = (number: string | number): string => number.toString().replace(/(.)(?=(\d{3})+$)/g,'$1 ');

export const toCapitalize = (str: string):string => str.charAt(0).toUpperCase() + str.slice(1);


export const luhnCheck = (value: string): boolean => {
  value = value.replace(/\D/g, '');

  var nCheck = 0;
  var bEven = false;

  for (var n = value.length - 1; n >= 0; n--) {
    var nDigit = parseInt(value.charAt(n), 10);

    if (bEven && (nDigit *= 2) > 9) {
      nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 == 0;

};